<div class="nav-bar custom-container py-2 ps-2" data-testid="navigation-card" *transloco="let t">
  <div class="row g-2">
    <!-- Scenario Manager link -->
    <div class="col-12 col-lg-6">
      <div (click)="toDashboard()" class="card d-flex" role="button" data-testid="manage-scenarios-link">
        <div class="nav-picture-container">
          <div class="nav-picture">
            <img alt="Card image scenario manager" src="assets/images/home/dashboard@2x.webp" />
          </div>
          <div class="nav-icon">
            <mat-icon class="ad-text-white">architecture</mat-icon>
          </div>
        </div>
        <div class="p-2">
          <h5 (click)="toDashboard()" class="fw-bold fs-6 ad-text-blue">{{ t('navbar.dashboard') }}</h5>
          <p>{{ t('home.box1') }}</p>
        </div>
      </div>
    </div>

    <!-- Scenario Browse link -->
    <div class="col-12 col-lg-6">
      <div (click)="toSceneBrowse()" class="card d-flex" role="button" data-testid="browse-scenarios-link">
        <div class="nav-picture-container">
          <div class="nav-picture">
            <img alt="Card image scenario browse" src="assets/images/home/sceneBr@2x.webp" />
          </div>
          <div class="nav-icon">
            <mat-icon class="ad-text-white">search</mat-icon>
          </div>
        </div>
        <div class="p-2">
          <h5 class="fw-bold fs-6 ad-text-blue">{{ t('navbar.consultation') }}</h5>
          <p class="card-text">{{ t('home.box2') }}</p>
        </div>
      </div>
    </div>
  </div>
</div>
